const LIMITS = [10, 20, 50, 100];

export const findOptimalLimit = (totalCount: number): number | null => {
  // If the total count is greater than the last limit (100), return null
  return totalCount > LIMITS[LIMITS.length - 1]
    ? null
    : LIMITS.find((limit) => limit >= totalCount) || LIMITS[LIMITS.length - 1];
};
